import { Link } from "@tanstack/react-router"

import { Button } from "@/components/ui/button"
import { Card, CardTitle } from "@/components/ui/card"
import ReferralsTrackerImage from "@/svg/home/referrals-tracker.svg?react"

export function HomeReferralsCard() {
  return (
    <Card className="@container min-w-0 overflow-hidden p-6">
      <div className="grid h-full grid-cols-1 grid-rows-[auto_1fr] gap-4 @md:grid-cols-[1fr_auto]">
        <CardTitle>Referrals</CardTitle>
        <ReferralsTrackerImage className="pointer-events-none row-span-2 hidden h-full w-48 @md:block" />
        <div className="flex min-w-0 flex-col justify-between">
          <p className="mb-4">
            Track all the businesses you’ve referred in one place, and get
            updates on their funding application status and next steps.
          </p>
          <Button className="bg-primary self-start" asChild>
            <Link to="/partners/referrals">Referrals Dashboard</Link>
          </Button>
        </div>
      </div>
    </Card>
  )
}
